import Layout from '@/layout/index.vue'

export const GrupareContracteRoute = {
  path: '/grupare-contracte',
  component: Layout,
  redirect: '/grupare-contracte',
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "grupare-contracte-index" */ '@/features/grupare-contracte/views/index.vue'),
      name: 'GrupareContracteIndexRoute',
      meta: {
        title: 'GrupareContracteIndexRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'create',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "grupare-contracte-create" */
          '@/features/grupare-contracte/views/create-update-grupare.vue'),
      name: 'GrupareContracteCreateRoute',
      meta: {
        title: 'GrupareContracteCreateRouteTitle',
        requiresAuth: true,
        action: 'create'
      }
    },
    {
      path: 'update/:grupareContracteId',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "grupare-contracte-update" */
          '@/features/grupare-contracte/views/create-update-grupare.vue'),
      name: 'GrupareContracteUpdateRoute',
      meta: {
        title: 'GrupareContracteUpdateRouteTitle',
        requiresAuth: true,
        action: 'update'
      }
    },
    {
      path: 'view/:grupareContracteId',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "grupare-contracte-details" */ '@/features/grupare-contracte/views/details.vue'),
      name: 'GrupareContracteDetailsRoute',
      meta: {
        title: 'GrupareContracteDetailsRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
